import React, { useRef, useState, useEffect } from 'react';
import { useAuthDataContext } from '../../../../../_providers/Auth';
import Api from '../../../../../_helpers/Api';
import editIcon from '../../../../../assets/img/icons/edit-yellow.png';
import Modal from './modals/Preferences';
import Skeleton from 'react-loading-skeleton';
import { trans } from '../../../../../_providers/Translation';

function Preferences() {

    const auth = useAuthDataContext();

    const modalRef = useRef(null);

    const [state, setState] = useState({
        loading: true,
        data: [],
        update: false,
    });

    useEffect(() => {
        loadSettings();
    }, [state.update]);

    const loadSettings = () => {
        Api.get('partners/settings/all?id=' + auth.user().partner_id)
            .then(res => {
                setState(prev => ({
                    ...prev,
                    loading: false,
                    data: res.data
                }));
            }).catch(err => {
                setState(prev => ({
                    ...prev,
                    loading: false
                }));
            });
    }

    const handleUpdate = () => {
        setState(prev => ({
            ...prev,
            update: new Date().getTime()
        }));
    }

    const showModal = () => {
        let modal = modalRef.current;

        modal.show(state.data);

        modal.onSave(() => {
            handleUpdate();
        });
    }

    return (
        <>
            <div className="head">
                <h4>{trans('headings.preferences')}</h4>
                <a onClick={showModal}>
                    <img src={editIcon} alt="" />
                </a>
            </div>

            {state.loading
                ?
                <Skeleton height={35} count={2} />
                :
                <>
                    <Modal
                        ref={modalRef}
                    />

                    <table className="settings">

                        <tbody>
                            <tr>
                                <td>
                                    <b>{trans('tables.language')}</b>
                                </td>
                                <td>
                                    {state.data.language ? state.data.language.name : trans('messages.notSelected')}
                                </td>
                                <td>

                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <b>{trans('random.timeZone')}</b>
                                </td>
                                <td>
                                    {state.data.timezone ? state.data.timezone : trans('messages.notSelected')}
                                </td>
                                <td>

                                </td>
                            </tr>
                        </tbody>
                    </table>
                </>
            }
        </>
    )

}

export default Preferences